import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { LUSource } from '../models/luSource';
import { CallNumberModel } from '../models/callNumberModel';
import { SourceCallNoFilterComponent } from '../source-call-no-filter/source-call-no-filter.component';
import { filterWindowSlideIn } from '../animations';
import { BreakpointService, BreakpointState } from '../breakpoint.service';

@Component({
  selector: 'app-source-call-no-box',
  templateUrl: './source-call-no-box.component.html',
  styleUrls: ['./source-call-no-box.component.css'],
  animations: [ filterWindowSlideIn ]
})
export class SourceCallNoBoxComponent implements OnInit, AfterViewInit {

  @Input() luSources: LUSource[] = [];
  @Input() callNumberData: CallNumberModel[] = [];
  @Input() activeFilters: CallNumberModel[] = [];
  @Input() activeFilter: CallNumberModel;

  @Output() sourceChanged = new EventEmitter<LUSource>();
  @Output() callNumberChanged = new EventEmitter<{callNumber: string; level: number}>();
  @Output() filterSet: EventEmitter<CallNumberModel[]> = new EventEmitter<CallNumberModel[]>();
  @Output() closePressed: EventEmitter<any> = new EventEmitter<any>();
  @Output() clearPressed: EventEmitter<any> = new EventEmitter<any>();
  @Output() levelOfSpecificity = new EventEmitter<number>();

  @ViewChild('sourceCallNoCmp') sourceCallNoCmp: SourceCallNoFilterComponent;
  @ViewChild('filterBox') filterBox: ElementRef;

  isOffScreen = false;

  show: string; // animate trigger

  private _subscription;
  isHandset: boolean = false;

  constructor(private breakpointService: BreakpointService) {
    this._subscription = this.breakpointService.handset$.subscribe(
      isHandset => {
        this.isHandset = isHandset;
      }
    )
  }

  ngOnInit() {


    this.show = 'in';
  }

  ngAfterViewInit() {
    this.isOffScreen = (this.filterBox.nativeElement.getBoundingClientRect().bottom - window.innerHeight) > 0;
  }

  done(filter: CallNumberModel[]): void {
    this.activeFilters = filter;
    if (this.activeFilters && this.activeFilters.length) {
      this.filterSet.emit(this.activeFilters);
      // this.closeFilterBox(false);
    }
  }

  public resetInnerCmpDropdowns(): void {
    this.sourceCallNoCmp.working = true;
    this.sourceCallNoCmp.resetCallNumberDropdowns();
    this.sourceCallNoCmp.working = false;
  }

  /** Tells parent component to close the box.
   *
   * @param cancel If cancel is true, the filter data set here will be cleared. */
  closeFilterBox(cancel: boolean): void {
    if (cancel) {
      this.activeFilters = [];
      this.resetInnerCmpDropdowns();
      this.filterSet.emit(this.activeFilters);
      this.clearPressed.emit();
    }
    this.show = 'out';
    setTimeout(() =>
      this.closePressed.emit(), 300);
  }

}
